import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" {...props}><path fill="#C4C4C4" d="M6.92 6.921C5.734 8.11 4.36 9.244 3.814 8.701c-.78-.779-1.26-1.457-2.976-.078-1.712 1.38-.396 2.298.356 3.053.872.87 4.116.045 7.32-3.16 3.204-3.206 4.032-6.448 3.16-7.319-.756-.754-1.672-2.071-3.052-.355-1.38 1.715-.7 2.195.076 2.973.544.544-.592 1.919-1.78 3.106z" /></svg>);